module.exports = __webpack_public_path__ + "img/microphone-disabled.e3fd216d.svg";